// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
  background: #f5f5f5;
}

.container {
  width: 200px;
  height: 200px;
  background-size: cover;
  vertical-align: middle;
  margin: 15% auto;
}

.fa-linkedin {
  display: block;
  font-size: 5em;
  text-align: center;
  color: #1C1F3E;
}

.line {
  height: 3px;
  width: 100%;
  background: #e8e8e8;
  margin-top: 20%;
}
.line .inner {
  width: 100%;
  height: inherit;
  background: #1C1F3E;
  animation: slide 2s ease-in-out infinite;
}

@keyframes slide {
  0% {
    transform-origin: left;
    transform: scalex(0.3);
  }
  25% {
    transform-origin: left;
    transform: scalex(1);
  }
  26% {
    transform-origin: right;
    transform: scalex(1);
  }
  50% {
    transform-origin: right;
    transform: scalex(0.3);
  }
  75% {
    transform-origin: right;
    transform: scalex(1);
  }
  76% {
    transform-origin: left;
    transform: scalex(1);
  }
  100% {
    transform-origin: left;
    transform: scalex(0.3);
  }
}`, "",{"version":3,"sources":["webpack://./src/components/loading/loading.css"],"names":[],"mappings":"AAAA;EACE,SAAS;EACT,UAAU;EACV,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,cAAc;EACd,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,WAAW;EACX,mBAAmB;EACnB,eAAe;AACjB;AACA;EACE,WAAW;EACX,eAAe;EACf,mBAAmB;EACnB,wCAAwC;AAC1C;;AAEA;EACE;IACE,sBAAsB;IACtB,sBAAsB;EACxB;EACA;IACE,sBAAsB;IACtB,oBAAoB;EACtB;EACA;IACE,uBAAuB;IACvB,oBAAoB;EACtB;EACA;IACE,uBAAuB;IACvB,sBAAsB;EACxB;EACA;IACE,uBAAuB;IACvB,oBAAoB;EACtB;EACA;IACE,sBAAsB;IACtB,oBAAoB;EACtB;EACA;IACE,sBAAsB;IACtB,sBAAsB;EACxB;AACF","sourcesContent":["body {\n  margin: 0;\n  padding: 0;\n  box-sizing: border-box;\n  background: #f5f5f5;\n}\n\n.container {\n  width: 200px;\n  height: 200px;\n  background-size: cover;\n  vertical-align: middle;\n  margin: 15% auto;\n}\n\n.fa-linkedin {\n  display: block;\n  font-size: 5em;\n  text-align: center;\n  color: #1C1F3E;\n}\n\n.line {\n  height: 3px;\n  width: 100%;\n  background: #e8e8e8;\n  margin-top: 20%;\n}\n.line .inner {\n  width: 100%;\n  height: inherit;\n  background: #1C1F3E;\n  animation: slide 2s ease-in-out infinite;\n}\n\n@keyframes slide {\n  0% {\n    transform-origin: left;\n    transform: scalex(0.3);\n  }\n  25% {\n    transform-origin: left;\n    transform: scalex(1);\n  }\n  26% {\n    transform-origin: right;\n    transform: scalex(1);\n  }\n  50% {\n    transform-origin: right;\n    transform: scalex(0.3);\n  }\n  75% {\n    transform-origin: right;\n    transform: scalex(1);\n  }\n  76% {\n    transform-origin: left;\n    transform: scalex(1);\n  }\n  100% {\n    transform-origin: left;\n    transform: scalex(0.3);\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
